import { render, staticRenderFns } from "./ed-list-class-teachers.component.vue?vue&type=template&id=49d52f87&scoped=true&"
import script from "./ed-list-class-teachers.component.ts?vue&type=script&lang=ts&"
export * from "./ed-list-class-teachers.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-list-class-teachers.component.scss?vue&type=style&index=0&id=49d52f87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d52f87",
  null
  
)

export default component.exports